










































































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import Course from '../../../api/v2/models/course'
import TermInUse from '../atoms_molecules/TermInUse.vue'
import { Card, createToken } from 'vue-stripe-elements-plus'
import api from '../../../api/v2/api'
import { ROUTER_NAME } from '../../router'
import { userState } from '../../stores/user'

@Component({
  components: {
    TermInUse,
    Card
  }
})
export default class CoursePurchase extends Vue {
  get user(){
    return userState.user
  }
  course: Course = null
  hasAgreed: boolean = false
  hasInstallment: boolean = false
  currentInstallment: number = 1
  complete: boolean = false
  canClick: boolean = true
  isShowSuccess: boolean = false
  isShowFail: boolean = false
  getDiscount: string = ""
  couponCode: string = ""
  purchasePrice: number = 0
  stripePublishableKey: string = ""
  breadcrumbs = [
    {
      text: 'コース一覧',
      disabled: false,
      exact: true,
      to: '/classroom/courses'
    }
  ]

  async created() {
    try {
      this.course = await api.course.show(this.$route.params.courseId)
      this.purchasePrice = this.course.purchasePrice
      this.breadcrumbs.push({
        text: this.course.name,
        disabled: false,
        exact: true,
        to: `/classroom/courses/${this.course.id}`
      })
    } catch (e) {
    }
  }

  async getCoupon() {
    try {
      const coupon = await api.coursePurchase.getCoupon(parseInt(this.$route.params.courseId), { couponCode: this.couponCode })
      if(coupon) {
        this.getDiscount = `- ${coupon.discountPrice.toLocaleString()}円`
        this.purchasePrice = coupon.purchaseDiscountPrice
        this.isShowSuccess = true
        this.isShowFail = false
      }
    } catch(e) {
      this.getDiscount = ""
      this.purchasePrice = this.course.purchasePrice
      this.isShowSuccess = false
      this.isShowFail = true
    }
  }

  async purchase() {
    this.canClick = false
    try {
      const tokenResponse = await createToken()
      await api.coursePurchase.create(
        this.$route.params.courseId, { 
          stripeToken: tokenResponse.token.id,
          installmentCount: this.hasInstallment ? this.currentInstallment : 1
        })
      this.$router.push({
        name: ROUTER_NAME.MY_COURSE_DETAIL,
        params: {
          courseId: this.course.id.toString()
        }
      })
    } catch (e) {
    } finally {
      this.canClick = true
    }
  }

  cancelCoupon() {
    this.getDiscount = ""
    this.purchasePrice = this.course.purchasePrice
    this.isShowSuccess = false
    this.isShowFail = false
    this.couponCode = ""
  }


  @Watch('user')
  async checkPurchaseNecessary() {
    if (this.user) {
      try {
        const coursePurchase = await api.coursePurchase.show_by_course(this.$route.params.courseId)
        if ((Boolean(coursePurchase) && Boolean(Object.keys(coursePurchase).length)) || ( this.user.latestSubscription && this.user.latestSubscription.isActive)) {

          return this.$router.push({
            name: ROUTER_NAME.MY_COURSE_DETAIL,
            params: {
              examId: this.$route.params.courseId
            }
          })
        }
      } catch(e) {
      }
    }
  }
}
